import {FORM_ERROR} from '@constants/messages';

export function renderAdSpliceFormErrorMessages() {
    return FORM_ERROR('Ad splice config');
}